import { notifications } from "@mantine/notifications"

import { queryClient } from "~/backend/queryClient"
import { findIngestionsQueryKey, useRevertImport } from "~/gen/api"

export const useRevertImportMutation = () =>
  useRevertImport({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries(findIngestionsQueryKey())
        notifications.show({
          title: "Success",
          message: "Ingestion reverted",
          color: "teal",
        })
      },
      onError: (error) => {
        notifications.show({
          title: "Error",
          message: error.message,
          color: "red",
        })
      },
    },
  })
